var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50001 0.233276C2.27251 0.233276 0.466675 2.03911 0.466675 4.26661C0.466675 6.91908 3.08908 8.18884 3.41761 8.48438C3.75311 8.78614 4.03031 9.46264 4.14214 9.84618C4.19641 10.0324 4.34894 10.1267 4.50001 10.1307C4.65144 10.1263 4.80361 10.0321 4.85787 9.84618C4.96971 9.46264 5.24691 8.78651 5.58241 8.48438C5.91094 8.18884 8.53334 6.91908 8.53334 4.26661C8.53334 2.03911 6.72751 0.233276 4.50001 0.233276ZM4.50001 5.36661C3.89244 5.36661 3.40001 4.87418 3.40001 4.26661C3.40001 3.65904 3.89244 3.16661 4.50001 3.16661C5.10757 3.16661 5.60001 3.65904 5.60001 4.26661C5.60001 4.87418 5.10757 5.36661 4.50001 5.36661Z",
    fill: "#555770"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.15dbd423191a6d3e38988e08579006f6.svg";
export { ForwardRef as ReactComponent };